import { render, staticRenderFns } from "./Chiefs.vue?vue&type=template&id=df7483b6&scoped=true"
import script from "./Chiefs.vue?vue&type=script&lang=js"
export * from "./Chiefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7483b6",
  null
  
)

export default component.exports